import React from 'react';
import './GuestHomeHeader.css';

/**
 * GuestHomeHeader — #2098 call 2 ("Sign in is the least prominent of the
 * three options and could easily be missed by returning users").
 *
 * DECIDED (Gilbert, 2026-08-12): move Sign in to a persistent top-right
 * header on the guest homepage. Before this, the default homepage rendered
 * NO `<header>`/`<nav>` element at all — Sign in was a borderless,
 * underlined text button below both hero CTAs (`.gd-hero-signin`,
 * `GuestWelcomeHero.jsx`, now removed). This is that small new component,
 * not a restyle of the old link.
 *
 * Renders ONLY on the default (non-audience) homepage — same gate
 * `HomePageV2.jsx` already applies to `GuestWelcomeHero` (`!audienceSlug`):
 * `/for/:audience` partner pages keep their own hero-embedded Sign in
 * button untouched, this header must never double up with it.
 *
 * Pure presentational — `onSignIn` opens the existing `LoginModal`, same
 * handler `GuestWelcomeHero` used to receive directly.
 */
function GuestHomeHeader({ onSignIn }) {
  return (
    <header className="gd-home-header">
      <button
        type="button"
        className="gd-home-header__signin"
        data-testid="gd-home-header-signin"
        onClick={onSignIn}
      >
        Sign in
      </button>
    </header>
  );
}

export default GuestHomeHeader;
